// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as LoaderComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/loader/LoaderComponent.bs.js";
import * as DriverTerminationListVMMapper from "../../vm-mapper/termination-list/DriverTerminationListVMMapper.bs.js";
import * as DriverTerminationListViewMapper from "./DriverTerminationListViewMapper.bs.js";

function DriverTerminationList$DriverTerminationLogs(Props) {
  var data = Props.data;
  var viewModel = DriverTerminationListVMMapper.DriverTerminationListVMMapper.getVm(data);
  return React.createElement("div", undefined, DriverTerminationListViewMapper.DriverTerminationListViewMapper.getView(viewModel));
}

var DriverTerminationLogs = {
  make: DriverTerminationList$DriverTerminationLogs
};

var TerminationLogsLoaderConfig = {};

var TerminationLogsLoaderComponent = LoaderComponent$Catalyst.LoaderComponentWithoutRefresh(TerminationLogsLoaderConfig);

function DriverTerminationList$TerminationLogsLoader(Props) {
  var msisdn = Props.msisdn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return React.createElement(TerminationLogsLoaderComponent.make, {
              fetchData: (function (param) {
                  var RepoInstance = CrmRepoManager.getTerminationRepo(undefined);
                  return Curry._2(RepoInstance.fetchTerminationInfo, msisdn, country);
                }),
              renderView: (function (data) {
                  return React.createElement(DriverTerminationList$DriverTerminationLogs, {
                              data: data
                            });
                })
            });
}

var TerminationLogsLoader = {
  TerminationLogsLoaderConfig: TerminationLogsLoaderConfig,
  TerminationLogsLoaderComponent: TerminationLogsLoaderComponent,
  make: DriverTerminationList$TerminationLogsLoader
};

export {
  DriverTerminationLogs ,
  TerminationLogsLoader ,
  
}
/* TerminationLogsLoaderComponent Not a pure module */
